module.exports = __webpack_public_path__ + "static/media/logo-nagamas.de3252db.png";